import config from "../config.json";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Slide, ToastContainer, toast } from "react-toastify";
import DownloadApp from "./DownloadApp";

const Hero = () => {
  const [activityCode, setactivityCode] = useState("");
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (activityCode) {
      // Navigate to the user profile page with the userId as a parameter
      navigate(`/feedback/${activityCode}`);
    } else {
      toast.error(config["FEEDBACK-UI-INPUT-VALIDATION-MESSAGE"], {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        bodyClassName:"toast-body",
        transition: Slide,
        });
    }
  };
  return (
    <section className="hero-area">
      <div className="hero-circle"></div>

      <div className="container">
        <div className="hero">
          <div className="hero__content">
            <h1 style={{color: "black", marginBottom: "20px"}}>
              Turn Feedback into Growth
            </h1>
            <p style={{fontSize: "20px", textAlign: "center", marginBottom: "30px", color: "#6c6c6c"}}>
              Surveys your customers love to complete. Get actionable insights in minutes, not months.
            </p>
            <br/><br/>
            <DownloadApp />

            <div style={{textAlign: "center", marginTop: "10px", color: "#1a6f3f", fontSize: "16px", fontWeight: "500"}}>
              ✓ No credit card required  &nbsp;&nbsp; ✓ Setup in 2 minutes  &nbsp;&nbsp; ✓ 10+ businesses trust us
            </div>
            {/* Activity Code Input Section
            <div style={{textAlign: "center", marginTop: "40px"}}>
              <button 
                onClick={() => setactivityCode('')}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#6c6c6c",
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: "14px"
                }}
              >
                Have an activity code? Click here
              </button>
            </div>
               */}
            {activityCode !== null && (
              <div className="activity-code-container" style={{marginTop: "90px"}}>
                <label>Have a survey code?</label>
                <div className="activity-code-container-inner">
                  <input
                    type="text"
                    id="activityCode"
                    className="activity-code__input"
                    value={activityCode}
                    onChange={(e) => setactivityCode(e.target.value)}
                    placeholder="Enter code here"
                  />
                  <button type="button" onClick={handleNavigate}>
                    GO
                  </button>
                </div>
              </div>
            )}

            {/* <img className="hero__image" src="/images/hero.png" alt="hero" /> 
            <video controls poster="/images/hero.png"
                            className="hero__image"
                            src="/images/appvideo.mp4"
                        />*/}
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default Hero;
